import React from 'react';

import Pill from 'common/common/Pill';
import styles from 'css-module/components/ideas/_IdeaStatusPill.module.scss';

import type { IdeaStatus } from 'common/api/resources/statuses';
import type { ColorValues } from 'common/colors/constants';

type Props = {
  status: IdeaStatus;
};

const IdeaStatusPill = ({ status }: Props) => {
  return (
    <Pill
      className={styles.ideaStatusPill}
      pillStyle={{
        color: status.color as ColorValues,
        background: `${status.color}20` as ColorValues,
      }}>
      {status.name}
    </Pill>
  );
};

export default IdeaStatusPill;
